module.exports = __webpack_public_path__ + "img/CarFinance247-logo.2f0e7529.svg";